import request from './request';
import Vue from 'vue';

var url = process.env.VUE_APP_API_URL;
var urlEs = process.env.VUE_APP_ES_URL;

export default {
  uploadImgUrl: url + '/api/file/uploadFile',
  uploadImgs: url + '/api/admin/uploads',
  imageHost: 'https://image.talk2best.cn',
};

//------------用户操作日志---------
//添加
export const addLog = (query) => {
  return request({
    url: '/api/operate_log/addLog',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//列表
export const queryLog = (query) => {
  return request({
    url: '/api/operate_log/queryLog',
    method: 'post',
    data: {
      data: query,
    },
  });
};
//---------end---------



// 获取所有分类(树型结构)
export const zgsourceAllCategory = (query) => {
  return request({
    url: '/api/zgsource_manage/category/allCategory',
    method: 'post',
    data: query,
  });
};
export * from './modules/article';
export * from './modules/class';
export * from './modules/course';
export * from './modules/live';
export * from './modules/manage';
export * from './modules/paper';
export * from './modules/user';
export * from './modules/zgconfig';
export * from './modules/question';
export * from './modules/exam';
